<template>
 <div>
  <div class="detailsTitle" >
      <h4>付款</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
       <div class="searchBtnBox">
           <el-form-item>
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
           <el-form-item label="应付合计:" prop="">
            <span class="red">{{tongji.totalPayable?tongji.totalPayable.toFixed(2):'0.00'}}元</span>
          </el-form-item>
          <el-form-item label="实付合计:" >
            <span class="red">{{tongji.amountMoney?tongji.amountMoney.toFixed(2):'0.00'}}元</span>
          </el-form-item>
          <el-form-item label="未付合计:"  v-if="tongji.totalPayable-tongji.amountMoney>0">
            <span class="red">{{(tongji.totalPayable-tongji.amountMoney).toFixed(2)}}元</span>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="160">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
                <el-button type="text" size="mini" @click="lookFn(scope.row)">付款凭证</el-button>
              </div>
            </template>
        </el-table-column>
         <el-table-column property="payType" width="110" label="付款类别" >
          <template scope="scope">
            {{[ "定金", "运费" ,"滞期费","其他"][scope.row.payType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="amountMoney" min-width="200"  :formatter="emptyFn" label="付款金额(元)"></el-table-column>
        <el-table-column prop="remark" :show-overflow-tooltip="true"  min-width="200" :formatter="emptyFn" label="备注"></el-table-column>
        <el-table-column prop="payUserName"  min-width="200" :formatter="emptyFn" label="付款人"></el-table-column>
        <el-table-column prop="payTime" width="170" :formatter="dateTimeFormat"  label="付款时间"></el-table-column>
        <el-table-column prop="createUserName" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="700px" center>
      <span>
         <el-form :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
              <el-form-item label="付款类别:" class="jiage" prop="payType">
                <el-select  v-model="addFrom.payType"    placeholder="请选择">
                  <el-option label="定金" :value="1" ></el-option>
                  <el-option label="运费" :value="2" ></el-option>
                  <el-option label="滞期费" :value="3" ></el-option>
                  <el-option label="其他" :value="4" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="付款金额(元):" prop="amountMoney" class="jiage">
                <el-input  placeholder=""  v-number-input.float="2"  maxlength="11" v-model="addFrom.amountMoney" :clearable="true" ></el-input>
              </el-form-item>
              <el-form-item label="付款凭证:"  >
                  <div class="imgBox" v-if="dialogVisible">
                    <uploadImgs :imgList.sync='imgList' :max=5 @remove='remove'></uploadImgs>
                  </div>
              </el-form-item>
           <el-form-item label="备注:" class="remark" prop="remark" >
              <el-input  placeholder=""   maxlength="20" v-model="addFrom.remark"></el-input>
            </el-form-item>
            <el-form-item label="付款人:"  prop="payUserName" >
              <el-input  placeholder=""   maxlength="20" v-model="addFrom.payUserName"></el-input>
            </el-form-item>
            <el-form-item label="付款时间:" prop="payTime" >
                <el-date-picker
                    v-model="addFrom.payTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    type="datetime"
                      placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">保存</el-button>
      </span>
    </el-dialog>
     <!-- 付款凭证 -->
    <el-dialog  title="付款凭证"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"    :visible.sync="FKPZdialog" width="1000px" center>
      <span>
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>付款凭证</span>
            </h4>
            <div class="">
              <el-image
                v-for="(item,index) in zhanshiList" :src="item" :key="index"
                style="width: 290px; height: 200px ; margin-right: 30px;"
                :preview-src-list="getSrcList(index,zhanshiList)">
              </el-image>
          </div>
        </div>
      </span>
       <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="FKPZdialog = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sShipPayList, addOrUpdatePay, sShipPayDelete, settlementFile } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {
    uploadImgs
  },
  data () {
    var id = this.$route.query.id
    let totalPayable = this.$route.query.totalPayable
    return {
      id: id,
      totalPayable: totalPayable,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      dialogVisible: false,
      isAdd: true,
      tableList: [],
      searchFrom: {
        settlementId: id,
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      tongji: {},
      ids: [],
      loading: 'false',
      rules: {
        amountMoney: [
          { required: true, message: '请输入付款金额', trigger: 'blur' }
        ],
        payType: [
          { required: true, message: '请选择付款时间', trigger: 'blur' }
        ]

      },
      addFrom: {
      },
      imgList: [],
      zhanshiList: [],
      FKPZdialog: false,
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00KM070100', '00KM070200', '00KM070300', '00KM070400', '00KM070500',
        '00KM070600', '00KM070700', '00KM070800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 135) + 'px'
  },
  methods: {
    // 付款凭证
    lookFn (row) {
      this.zhanshiList = []
      settlementFile({ id: row.id, type: 2 }).then(res => {
        if (res.length > 0) {
          res.forEach(item => {
            this.zhanshiList.push(item.fileUrlOSS)
          })
          this.FKPZdialog = true
        } else {
          this.$alert('该结算下面没有付款凭证', '系统提示')
        }
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 导出
    exportFn () {
      let form = { settlementId: this.id }
      exportExcel(
        this.global.shipping + '/sShipPay/exportPayList',
        form,
        '付款单据'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sShipPayList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.tongji = res.map
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.addFrom = { settlementId: this.id }
      this.dialogVisible = true
      this.isAdd = true
      this.$set(this.addFrom, 'payTime', new Date().getTime())
      this.$set(this.addFrom, 'payUserName', localStorage.getItem('userName'))
      // this.$set(this.addFrom, 'amountMoney', this.tongji.totalUnpaid)
    },
    editFn (row) {
      this.addFrom = { ...row }
      this.imgList = []
      this.$set(this.addFrom, 'delFileIds', [])
      settlementFile({ id: row.id, type: 2 }).then(res => {
        if (res.length > 0) {
          res.forEach((item, index) => {
            this.$set(this.imgList, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
          })
        }
        this.dialogVisible = true
        this.isAdd = false
      })
    },
    // 删除图片
    remove (file) {
      if (file.id) {
        this.addFrom.delFileIds.push(file.id)
      }
    },
    saveFn (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.imgList.length == 0) {
          //   this.$alert('请添加付款凭证', '系统提示')
          //   return
          // }
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify(this.addFrom))
          let arr = []
          this.imgList.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          compressImages(arr, {
            width: 1000
          }).then(result => {
            result.forEach(item => {
              imgfile.append('files', item)
            })
            that.save1(imgfile)
          })
        } else {
          return false
        }
      })
    },
    save1 (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addOrUpdatePay(data).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipPayDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = { }
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
      this.imgList = []
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  flex-direction:column;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}

.jiage{
  position: relative;
  .danwei1{
    position: absolute;
       left: 160px;
  }
}
/deep/.inpBox .el-input__inner{
 width: 180px;
}
.jiage /deep/.el-form-item__content{
  width: 180px;
}
</style>
